/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!*************************************!*\
  !*** ./src/scripts/sections/faq.js ***!
  \*************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var faq = function faq() {
  return {
    openAccordions: [],
    mobileSticky: null,
    accordionsWrapper: null,
    accordionWrapper: null,
    header: null,
    announcementBar: null,
    body: null,
    headerHeight: 0,
    init: function init() {
      var _this = this;
      this.mobileSticky = document.querySelector('.mobile-sticky');
      this.accordionsWrapper = document.querySelector('.accordions-wrapper');
      this.header = document.querySelector('#HeaderContent');
      this.announcementBar = document.querySelector('.announcement-bar');
      this.body = document.querySelector('html body');
      this.headerHeight = this.header.offsetHeight;
      var lastScroll = 0;
      window.addEventListener("scroll", function () {
        if (window.pageYOffset <= 0) {
          document.body.classList.remove('scroll-down-faq');
          return;
        }
        if (window.pageYOffset > 56 && window.pageYOffset > lastScroll && !document.body.classList.contains('scroll-down-faq')) {
          document.body.classList.add('scroll-down-faq');
        } else if (window.pageYOffset < lastScroll && document.body.classList.contains('scroll-down-faq')) {
          document.body.classList.remove('scroll-down-faq');
        }
        lastScroll = window.pageYOffset;
        if (!_this.body.classList.contains('scroll-down-faq')) {
          _this.mobileSticky.style.top = "".concat(_this.headerHeight, "px");
        } else {
          _this.mobileSticky.style.top = '20px';
        }
      });
    },
    toggleAccordion: function toggleAccordion(accordionNumber) {
      var index = this.openAccordions.indexOf(accordionNumber);
      if (index === -1) {
        this.openAccordions.push(accordionNumber);
      } else {
        this.openAccordions.splice(index, 1);
      }
    },
    scrollToSection: function scrollToSection(sectionId) {
      var section = document.getElementById(sectionId);
      if (section) {
        var offset = 150;
        var mediaQuery = window.matchMedia('(max-width: 980px)');
        if (mediaQuery.matches) {
          offset = 170;
        }
        var bodyRect = document.body.getBoundingClientRect().top;
        var elementRect = section.getBoundingClientRect().top;
        var elementPosition = elementRect - bodyRect;
        var offsetPosition = elementPosition - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (faq);
document.addEventListener("alpine:init", function () {
  Alpine.data("faq", faq);
});
/******/ })()
;